import { Language } from '@app/store/shared/models';
import { ProfileValue } from './profile.value';

export class ProfileValueDto {
    firstName: string;
    lastName: string;
    language: Language;

    constructor(data: ProfileValue) {
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.language = data.language;
    }
}
